<script>
import Vue from "vue";
import VTooltip from "v-tooltip";
Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import "v-tooltip/dist/v-tooltip.css";
import Loader from "@/components/widgets/loader";

export default {
    mixins: [Api, Sabit],
    props: ["UstDonemId", "DonemId","Sorgulama", "TabloId"],
    components: {
        Loader
    },
    data() {
        return {
            Page: {
                PageNumber: "1",
                PageSize: "9999",
                PageDataSize: "1",
            },
            TableData: {},
            DonemAdi: "",
            loading: true,
            uri: "data:application/vnd.ms-excel;base64,",
            template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
            base64: function (s) {
                return window.btoa(unescape(encodeURIComponent(s)));
            },
            format: function (s, c) {
                return s.replace(/{(\w+)}/g, function (m, p) {
                    return c[p];
                });
            },
        };
    },
    watch: {
        DonemId() {
            this.Get();
        },
                TabloId() {
            this.Get();
        },
    },
    methods: {
        groupBy: function (array, key) {
            const result = {};
            array.forEach((item) => {
                if (!result[item[key]]) {
                    result[item[key]] = [];
                }
                result[item[key]].push(item);
            });
            return result;
        },
        Get() {

            let Filter = "&DonemId=" + this.DonemId + "&UstDonemId=" + this.UstDonemId + "&TabloId=" + this.TabloId;
            this.ActionsFilterGet({ Service: "StrRaporlama/GetGostergeEslesenBirimlerTablosu", Page: this.Page, Filter: Filter }).then((res) => {
                this.TableData = res.Data;

            });
        },
        Fark(Data){
            var Fark = 0;
            if(Data){
              Fark = Data.Universitehedefi - Data.Birimbazlihedeftoplam  
            }
            return Fark;
        },
        getColor(birimlerHedefToplam, uniHedef) {
        const fark = birimlerHedefToplam - uniHedef;
    if (fark > 0) {
        return "rgba(144, 238, 144, 0.5)"; 
      } else if (fark < 0) {
        return "rgba(255, 99, 71, 0.5)"; 
      } else {
        return "rgba(211, 211, 211, 0.5)"; 
      }
        },
ExcelExport(table, name) {
    if (!table.nodeType) table = this.$refs.veriGiris;
    var html = table.innerHTML;

    // v:TextBox kullanarak dikey yazıyı zorla ve yüksekliği 200px yap
    html = html.replace(/style="writing-mode: vertical-rl; transform: rotate\(180deg\);[^"]*"/g, 
        'style="mso-rotate:90;height:400px;"'); 

    var ctx = { worksheet: name || 'Worksheet', table: html };
    var a = document.createElement('a');
    a.href = this.uri + this.base64(this.format(this.template, ctx));
    a.download = name + '.xls';
    a.click();
}


    },

    computed: {},
    created() {
        this.Get();
    },
};
</script>
<template>
    <Loader>
        <div>
            <div class="text-sm-end">
                <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="
                    ExcelExport(
                        'BirimBazlıHedefToplamlarıTablosu',
                        'BirimBazlıHedefToplamlarıTablosu',
                    )
                ">
                    <i class="mdi mdi-file-export-outline me-1"></i>
                    Excel'e Aktar
                </button>
            </div>
            <div ref="veriGiris" class="table-responsive">
                <div class="table-responsive">
                    <br>
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="table-responsive">
<table class="table-bordered col-md-12">
  <thead>
    <tr style="background-color:rgb(182, 221, 232); border-color:white; border-style: solid; text-align: center; height: 50px;">
      <th class="col-md-12" :colspan="TableData[0].gostergeler[0].birimtipler.map(b => b.birimler).reduce((acc, curr) => acc.concat(curr), []).length + 2">
        Gösterge/Birim Eşleştirme Tablosu
      </th>
    </tr>
    <tr style="background-color:rgb(182, 221, 232); border-color:white; border-style: solid; text-align: center; height: 50px;">
      <th colspan="1">Tablo Adı</th>
      <th :colspan="(TableData[0].gostergeler[0].birimtipler.map(b => b.birimler).reduce((acc, curr) => acc.concat(curr), []).length + 1)">
        {{ TableData[0].tablo }}
      </th>
    </tr>
    <tr style="background-color:rgb(182, 221, 232); border-color:white; border-style: solid; text-align: center; height: 50px;">
      <th rowspan="2">Gösterge</th>
            <th v-for="(birimtip, index) in TableData[0].gostergeler[0].birimtipler" :key="index" :colspan="birimtip.birimler.length" style="text-align: center;">
        {{ birimtip.birimTip }}
      </th>
      <th rowspan="2" style="writing-mode: vertical-rl; transform: rotate(180deg); text-align: center; white-space: normal; word-break: break-word; padding: 10px;">
        Toplam Eşleşmiş Birim Sayısı
      </th>

    </tr>
    <tr style="background-color:rgb(182, 221, 232); border-color:white; border-style: solid; text-align: center; height: 50px;">
      <th v-for="(birim, index) in TableData[0].gostergeler[0].birimtipler.map(b => b.birimler).reduce((acc, curr) => acc.concat(curr), [])" :key="index" style="writing-mode: vertical-rl; transform: rotate(180deg); text-align: center; white-space: normal; word-break: break-word; padding: 10px;">
        {{ birim.birim }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(gosterge, gIndex) in TableData[0].gostergeler" :key="gIndex">
      <td>{{ gosterge.gosterge }}</td>

      <td v-for="(birim, bIndex) in gosterge.birimtipler.map(b => b.birimler).reduce((acc, curr) => acc.concat(curr), [])" :key="bIndex" style="text-align: center;">
        {{ birim.gostergeTanimliMi ? '√' : '' }}
      </td>
            <td>
        {{ gosterge.birimtipler.map(b => b.birimler).reduce((acc, curr) => acc.concat(curr), []).filter(birim => birim.gostergeTanimliMi).length }}
      </td>
    </tr>
  </tbody>
</table>


                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
</Loader>
</template>
<style>
td {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
}

</style>
